import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  const maskContainerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.25,
        delayChildren: 0.2
      }
    }
  };

  const maskItemVariants = {
    hidden: { y: "150%", rotateZ: 5, opacity: 0 },
    visible: {
      y: 0,
      rotateZ: 0,
      opacity: 1,
      transition: { duration: 1.2, ease: [0.16, 1, 0.3, 1] }
    }
  };

  const restVariants = {
    hidden: { y: 40, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { delay: 1.8, duration: 1.2, ease: [0.16, 1, 0.3, 1] }
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="min-h-screen relative flex items-center pt-32 pb-24" id="home">
      <motion.div
        className="container mx-auto px-6 md:px-12 relative z-10"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <div className="flex flex-col items-center text-center max-w-5xl mx-auto">
          
          <motion.div variants={restVariants} className="mb-8">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm text-sm font-medium text-white/80">
              <span className="w-2 h-2 rounded-full bg-svnate-teal animate-pulse"></span>
              Next-Gen Digital Solutions
            </span>
          </motion.div>

          <motion.h1 
            variants={maskContainerVariants}
            initial="hidden"
            animate="visible"
            className="text-5xl sm:text-6xl md:text-8xl lg:text-[7rem] font-bold tracking-tight leading-[1.1] text-white mb-8"
          >
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 md:gap-8 overflow-hidden pb-4 px-4">
              <motion.span variants={maskItemVariants} className="inline-block origin-bottom-left">
                Crafting
              </motion.span>
              <motion.span variants={maskItemVariants} className="inline-block origin-bottom-left">
                Digital
              </motion.span>
            </div>
            
            <div className="overflow-hidden pb-8 px-8 -mx-8 -mb-4">
              <motion.span 
                variants={maskItemVariants} 
                className="inline-block origin-bottom-left font-serif italic font-normal text-transparent bg-clip-text bg-gradient-to-r from-svnate-lightTeal to-svnate-blue pr-6 pb-2 drop-shadow-[0_0_25px_rgba(255,255,255,0.4)]"
              >
                Masterpieces
              </motion.span>
            </div>
          </motion.h1>

          <motion.p 
            variants={restVariants} 
            className="font-serif text-lg md:text-2xl text-foreground/70 mb-12 max-w-3xl leading-relaxed"
          >
            We build scalable, immersive digital solutions for forward-thinking brands. 
            From concept to launch, we design products that captivate and convert.
          </motion.p>

          <motion.div
            variants={restVariants}
            className="flex flex-col sm:flex-row gap-6 items-center"
          >
            <button
              onClick={() => scrollToSection('portfolio')}
              className="group relative px-8 py-4 bg-white text-black rounded-full text-lg font-medium transition-all duration-300 hover:scale-105 flex items-center gap-3 shadow-[0_0_20px_rgba(255,255,255,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.5)]"
            >
              View Our Work
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
            
            <button
              onClick={() => scrollToSection('contact')}
              className="px-8 py-4 bg-white/5 text-white border border-white/10 rounded-full text-lg font-medium hover:bg-white/10 backdrop-blur-sm transition-all duration-300"
            >
              Contact Us
            </button>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
